import type { LeavingSiteEvent, Store } from "@inferno/renderer-shared-core";
import { inject } from "mobx-react";
import { useCallback, useRef } from "react";
import { ExternalLinkIcon } from "../../../core/components/icons/ExternalLinkIcon.component";
import { ClickSection } from "@inferno/renderer-shared-core";
import { isWindowDefined } from "@inferno/renderer-shared-core";

import styles from "./PremiereNav.module.scss";

export const PremiereLeavingSiteButton = inject("store")(
  ({
    label,
    url,
    context,
    type,
    store,
  }: {
    label: string;
    url: string;
    type: string;
    context?: string | null;
    store?: Store;
  }) => {
    if (!type || !store) {
      return null;
    }

    const contextRef = useRef(context);
    const trackClick = useCallback(
      (trackSectionName: string, trackHref: string | any) => {
        const page = store.page.currentPage;
        const pageName = page ? `${store.microsite ? "microsite_" : ""}${page.name}` : "";

        if (!contextRef.current) {
          if (label) {
            contextRef.current = label;
          } else if (typeof trackHref === "string") {
            contextRef.current = trackHref;
          } else {
            contextRef.current = "";
          }
        }

        let referrer = "";
        if (isWindowDefined()) {
          referrer = window.location.href;
        }

        store.onAnalyticsAction.dispatch({
          sectionName: trackSectionName,
          pageName,
          context: contextRef.current,
          action: "click",
          url: trackHref,
          referrer,
          type,
        } as LeavingSiteEvent);
      },
      [store, label, type],
    );

    return (
      <ClickSection.Consumer>
        {sectionVal => (
          <button
            aria-label={`${label || "menu item"}`}
            className={styles.menuLabel}
            onClick={() => trackClick(sectionVal, url)}
          >
            {label}
            <span className={styles.icon}>
              <ExternalLinkIcon />
            </span>
          </button>
        )}
      </ClickSection.Consumer>
    );
  },
);
